export default "__VITE_ASSET__C6P6nC1$__"